import {Formik, Field, Form, ErrorMessage} from 'formik';
import React, {useState} from 'react';
import * as Yup from 'yup';

/**
 * Component showed when user attempt to save form without filling email
 *
 * @param OnSaveFrom
 * @returns {JSX.Element}
 * @constructor
 */
const SaveForm = ({OnSaveFrom}) => {

	const initialValues = {
		email: ''
	}

	const onSubmit = (values) => {

		OnSaveFrom(values.email);
	}

	const validationSchema = Yup.object({
		email: Yup.string().email().required('Merci de renseigner votre email'),

	});

	return <>
		<Formik
			initialValues={initialValues}
			validationSchema={validationSchema}
			validateOnMount
			onSubmit={onSubmit}>

			{
				(formik) => {

					return <Form>
						<div className="form-card">

							<div style={{padding: '10px'}}>


								<div style={{
									minWidth: '394px',
									padding: '10px',
									margin: '10px',
									textAlign: 'center',
									display: 'table-caption'
								}} className="form-group  ">
									<p><strong> Afin de Sauvegarder votre formulaire, veuillez renseigner votre adresse
										emal</strong></p>

									<div className="container-input">
										<Field className="form-control" name="email" type="email"
											   placeholder="Saisissez votre email" title="Saisissez votre email"/>
										<ErrorMessage
											name="email"
											component="span"
											className="msg-error"
										/>
									</div>
								</div>

							</div>
						</div>

						<div style={{textAlign: 'center'}}>

							<button type='submit' className="bouton bouton-primary bouton-picto  bouton-wire  "><i
								className="fa fa-save" aria-hidden="true"></i>Sauvegarder et quitter
							</button>
						</div>
					</Form>
				}
			}


		</Formik>
	</>
}

export default SaveForm
